import { api } from './client'
import { requireArrayIn } from './readShape'

const vendorBillService = {
  getSummary: () => api.get('/vendor-bills'),
  getSettings: () => api.get('/vendor-bills/settings'),
  getProducts: () => api.get('/vendor-bills/products'),
  getVendorBill: (id) => api.get(`/vendor-bills/${id}`),
  getLineItems: (id, params = {}) => api.get(`/vendor-bills/${id}/line-items`, params),
  // CB answers with a DataTables envelope — `{ draw, recordsTotal, recordsFiltered,
  // data: [MemorizedModel] }` (AccountingController.GetMemorizedVBGrid) — which
  // cb-api wraps in its own `{ data }`. A wrong-shaped answer throws rather than
  // reading as "no recurring bills" (spec 136).
  getMemorized: async () => requireArrayIn(await api.get('/vendor-bills/memorized'), 'data', {
    noun: 'recurring bill list', emptyNoun: 'list', entryNoun: 'recurring bill',
  }),
  checkStatus: (id) => api.post(`/vendor-bills/${id}/check-status`),
}

export default vendorBillService
